import { defineAsyncComponent } from 'vue';
import { mountApp, app } from '@/js/app-entries/app-entry-points/global';

const ProviderPicker = defineAsyncComponent(() => import('@/js/comparisons/ProviderPicker.vue'));

app.component('ProviderPicker', ProviderPicker);

mountApp();
